import React from 'react';
import "./HomeBannerStyle.css";
import bgVideo from "../images/copy_C560E869-D562-4FF5-87ED-6E97D79F2842.MOV";
import { FaLinkedin, FaGithub } from "react-icons/fa";

export default function HomeBanner({id}) {
  return (
    <div className="home" id={id}> 
        <div className="video-bg-wrapper">
          <video
            className="video-bg"
            src={bgVideo}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="video-overlay" />
        </div>
        <div className='content'>
            <div className="wrapper">
              <div className="name">Ahmed K. Alrasheed</div>
              <div className="staticTitle">
                Ai Engineer
                <div className='hrLine'></div>
              </div>
              <ul className="dynamicTitle">
                <li>+<span>Developer</span></li>
              </ul>
              <div className="home-btns">
                <a className='btn' href="https://www.linkedin.com/in/ahmed-k-alrasheed-446b8829b/" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin size={20} style={{ marginRight: "8px", position: "relative", top: "2px" }} />
                  LinkedIn
                </a>
                <a className='btn btn-outline' href="https://github.com/Ahmed-1425/" target="_blank" rel="noopener noreferrer">
                  <FaGithub size={20} style={{ marginRight: "8px", position: "relative", top: "2px" }} />
                  GitHub
                </a>
              </div>
            </div>
        </div>
    </div>
  )
}
